module.exports = __webpack_public_path__ + "static/img/IMG_20160307_164807.98dfa8bd.jpg";